import React from 'react'

import {
  Body2,
  Body3,
  Box,
  Checkbox,
  Color,
  Display,
  FlexDirection,
  FontWeight,
  Heading5,
  Space,
  Text,
} from '@gousto-internal/citrus-react'

import {
  isCaloriePreferenceSelected,
  CALORIES_DISPLAY_PREFERENCE_TYPE,
} from '@library/api-menu-experience'
import type { DisplayPreference } from '@library/api-menu-experience'

type RecipeInformationProps = {
  displayPreferences: DisplayPreference[]
  onChange: (displayPreferences: DisplayPreference[]) => void
}

export const RecipeInformation = ({ displayPreferences, onChange }: RecipeInformationProps) => {
  const displayCalories = isCaloriePreferenceSelected(displayPreferences)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = event.target
    const updatedPreferences = displayPreferences.map((preference) =>
      preference.type === name ? { ...preference, selected: checked } : preference,
    )
    onChange(updatedPreferences)
  }

  return (
    <Box paddingV={2}>
      <Heading5>Recipe information</Heading5>
      <Body2>Edit the information you see on recipe cards</Body2>
      <Space size={3} direction="vertical" />
      <Checkbox
        id="show-calories-checkbox"
        name={CALORIES_DISPLAY_PREFERENCE_TYPE}
        checked={displayCalories}
        onChange={handleChange}
        outline
        paddingH={3}
        paddingV={3}
      >
        <Box display={Display.Flex} flexGrow={1} flexDirection={FlexDirection.Column}>
          <Text
            color={displayCalories ? Color.Secondary_400 : Color.ColdGrey_800}
            fontWeight={displayCalories ? FontWeight.Bold : FontWeight.Normal}
            size={3}
          >
            Calories (kcal)
          </Text>
          <Body3>Calories are always visible when you view more details of a recipe</Body3>
        </Box>
      </Checkbox>
    </Box>
  )
}
